import { useSelector } from 'react-redux';

import { selectFeatureFlags } from 'core/userContext';
import {
  BRAND_AFFINITY_NAMES_TO_I18N_KEYS,
  ensureBrandAffinityLevel,
  useBrandAffinityTranslation,
} from 'modules/domains/brandAffinity';

import { useProfileQueryContext } from '../../../contexts/demographicInsights';
import { InsightTable } from './InsightTable';
import { useTranslation } from '../../../hooks';

export const BrandAffinityLevelsTable = () => {
  const { t: segmentationTranslation } = useTranslation();
  const { t: brandAffinityTranslation } = useBrandAffinityTranslation();
  const isBrandAffinityEnabled = !!useSelector(selectFeatureFlags).BrandAffinity;
  const { brandAffinityLevels = [] } = useProfileQueryContext();

  if (!isBrandAffinityEnabled) {
    return null;
  }

  const translateBrandAffinityLevelName = (name: string) =>
    brandAffinityTranslation(BRAND_AFFINITY_NAMES_TO_I18N_KEYS[ensureBrandAffinityLevel(name)]);
  const labelledBrandAffinityLevels =
    brandAffinityLevels?.map(({ name, count }) => ({
      name: translateBrandAffinityLevelName(name),
      count,
    })) ?? [];

  const title = segmentationTranslation('insights.brandAffinity');
  return (
    <InsightTable
      title={title}
      hasChart
      values={labelledBrandAffinityLevels}
      isEnabled={!!labelledBrandAffinityLevels.length}
      showDivider
    />
  );
};
